var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.mixGetContratoActividadesTodas,"items-per-page":20},scopedSlots:_vm._u([{key:"item.tipo",fn:function(ref){
var item = ref.item;
return [_vm._v("\n      "+_vm._s(_vm.getTipo(item.tipo))+"\n    ")]}},{key:"item.fecha",fn:function(ref){
var item = ref.item;
return [_vm._v("\n      "+_vm._s(new Date(((item.fecha) + " 00:00:0")).toLocaleDateString())+"\n    ")]}},{key:"item.descripcion",fn:function(ref){
var item = ref.item;
return [_c('cortar-texto',{attrs:{"texto":item.descripcion}})]}},{key:"item.marcarResuelto",fn:function(ref){
var item = ref.item;
return [_c('BotonMarcarProbelmaResuelto',{attrs:{"contratoActividad":item}})]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }